var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_16_1",
    "data-name": "Component 16 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29.522,
    viewBox: "0 0 28 29.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-bell",
    "data-name": "Icon awesome-bell",
    d: "M12.916,29.522a3.69,3.69,0,0,0,3.688-3.69H9.227A3.69,3.69,0,0,0,12.916,29.522ZM25.335,20.89c-1.114-1.2-3.2-3-3.2-8.9A9.105,9.105,0,0,0,14.76,3.047v-1.2a1.844,1.844,0,1,0-3.688,0v1.2a9.105,9.105,0,0,0-7.377,8.946c0,5.9-2.084,7.7-3.2,8.9A1.8,1.8,0,0,0,0,22.141a1.847,1.847,0,0,0,1.851,1.845h22.13a1.846,1.846,0,0,0,1.851-1.845A1.8,1.8,0,0,0,25.335,20.89Z",
    fill: "#242529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.254568d2960830e556cc92c378380661.svg";
export { ForwardRef as ReactComponent };